export default defineNuxtRouteMiddleware((to, from) => {
	// 示例：认证中间件
	const isAuthenticated = useCookie('auth').value;

	if (!isAuthenticated && to.path !== '/login') {
		return navigateTo('/login');
	}
});
